import { InputAdornment } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";
import { visibility_icon } from "../images";

const useStyles = makeStyles(() => ({
  icon:{
    height : 30,
    width : 30
  },
  adornment: {
    cursor: "pointer",
    marginTop: 2,
  },
}));

/** 
 * Define VisibilityAdornment component to toggle visibility of password
 * 
 * @param {function} onClick - purpose
 * 
 * @return {InputAdornment component} 
 */
function VisibilityAdornment({ onClick }) {
  const classes = useStyles();
  return (
    <InputAdornment
      className={classes.adornment}
      onClick={onClick}
      position="start"
    >
      <img src = {visibility_icon} alt="visibility-icon" className={classes.icon}/>
    </InputAdornment>
  );
}

export default VisibilityAdornment;
VisibilityAdornment.propTypes = { onClick: PropTypes.func.isRequired };
